const LOCALE_ID = 'en';

export { LOCALE_ID };
